import { defineMessages } from 'react-intl';
import textLeftSVG from '@plone/volto/icons/align-left.svg';
import textRightSVG from '@plone/volto/icons/align-right.svg';

const messages = defineMessages({
  decoration: {
    id: 'Decoration',
    defaultMessage: 'Decoration',
  },
  position: {
    id: 'Position',
    defaultMessage: 'Position',
  },
  image: {
    id: 'Position',
    defaultMessage: 'Position',
  },
  vertical: {
    id: 'Vertical',
    defaultMessage: 'Vertical',
  },
  horizontal: {
    id: 'Horizontal',
    defaultMessage: 'Horizontal',
  },
  left: {
    id: 'Left',
    defaultMessage: 'Left',
  },
  right: {
    id: 'Right',
    defaultMessage: 'Right',
  },
  parrot: {
    id: 'Parrot',
    defaultMessage: 'Parrot',
  },
  jaguar: {
    id: 'Jaguar',
    defaultMessage: 'Jaguar',
  },
  plant: {
    id: 'Plant',
    defaultMessage: 'Plant',
  },
});

export const schemaDecoration = ({ intl }) => {
  return {
    required: [],
    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.decoration),
        fields: ['image'],
      },
      {
        id: 'Position',
        title: intl.formatMessage(messages.position),
        fields: ['horizontal', 'vertical'],
      },
    ],
    properties: {
      image: {
        title: intl.formatMessage(messages.image),
        default: 'plants',
        required: true,
        type: 'string',
        noValueOption: false,
        choices: [
          ['parrot', intl.formatMessage(messages.parrot)],
          ['jaguar', intl.formatMessage(messages.jaguar)],
          ['plant1', `${intl.formatMessage(messages.plant)} 1`],
          ['plant2', `${intl.formatMessage(messages.plant)} 2`],
          ['plant3', `${intl.formatMessage(messages.plant)} 3`],
          ['plant4', `${intl.formatMessage(messages.plant)} 4`],
          ['plant5', `${intl.formatMessage(messages.plant)} 5`],
        ],
      },
      vertical: {
        title: `${intl.formatMessage(messages.vertical)} (px)`,
        required: true,
        default: '0',
        type: 'number',
      },
      horizontal: {
        title: intl.formatMessage(messages.horizontal),
        default: 'left',
        required: false,
        type: 'string',
        widget: 'buttons',
        actions: ['left', 'right'],
        actionsInfoMap: {
          left: [textLeftSVG, intl.formatMessage(messages.left)],
          right: [textRightSVG, intl.formatMessage(messages.right)],
        },
      },
    },
  };
};

export default schemaDecoration;
